import { apiGet, apiPost, apiPut, apiPatch } from "./base";
import { QueryOptions } from "./base";

export const fetchPatient = async (patientId: string | number, signal?: AbortSignal) => {
  const url = `/api/patients/${patientId}/`;
  const response = await apiGet(url, signal);
  return response.data;
};

export const fetchCareGap = async (patientId: string | number, signal?: AbortSignal) => {
  const url = `/api/patients/${patientId}/care-gaps/?incomplete=true&page_size=100`;
  const response = await apiGet(url, signal);

  let next = response.data?.next;

  while (next) {
    const nextResponse = await apiGet(next, signal);
    response.data?.results.push(...nextResponse.data?.results);
    next = nextResponse.data?.next;
  }

  return response.data;
};

export const putCareGap = async (patientId: string | number, careGapId: string | number, data: any) => {
  const url = `/api/patients/${patientId}/care-gaps/${careGapId}/`;
  const response = await apiPut(url, data);
  return response.data;
};

export const putPatientData = async (patientId: string | number, data: any) => {
  const url = `/api/patients/${patientId}/`;
  const response = await apiPut(url, data);
  return response.data;
};

export const patchPatientData = async (patientId: string | number, data: any) => {
  const url = `/api/patients/${patientId}/`;
  const response = await apiPatch(url, data);
  return response.data;
};

export const fetchPatients = async (queryOptions: QueryOptions | null, pageParam?: string) => {
  const url = `/api/patients/search/?search_query=${queryOptions?.filter?.value}&sort_by=${queryOptions?.sort?.field}&sort_order=${queryOptions?.sort?.order}${queryOptions?.page ? `&page=${queryOptions?.page}` : ""}`;
  const response = await apiGet(pageParam ?? url);
  return response.data;
};

export const refreshSmartSummary = async (patientId: string | number) => {
  const url = `/api/patients/refresh_smart_summary/?patient_id=${patientId}`;
  const response = await apiPost(url);
  return response.data;
};
